import Manage from "..";
import { AiOutlinePlus } from "react-icons/ai";
import { useFetchAllStationsQuery } from "../../../store/endpoints/trace/stations";

export default function AllStations() {
  const { data: allStations, isLoading } = useFetchAllStationsQuery();

  const stations = !isLoading ? allStations && allStations.payload : [];

  return (
    <Manage
      title={"Stations"}
      subtitle={"All"}
      description={"List of all stations"}
      actions={
        <button className="border rounded-md px-2 py-1 flex items-center">
          <AiOutlinePlus />
          <span className="ml-2">New</span>
        </button>
      }
    >
      {stations?.map((station: any) => (
        <div className="bg-red-100">{station.name}</div>
      ))}
    </Manage>
  );
}
